// extracted by mini-css-extract-plugin
module.exports = {"list":"FeaturesLightboxList-module--list--2i7G5","listItem":"FeaturesLightboxList-module--listItem--sz44l"};